const listAttributes = [
  'markerId',
  'markedDatetime',
  'creationDatetime',
  'dueDatetime',
  'outcome',
  'mark',
  'maxMark',
  'questions',
  'student',
  'studentDetails',
  'markerDetails',
  'subject',
  'examId',
  'examLabel',
  'type',
  'attemptNumber',
  'unmarkedExamFileName',
  'markerComment',
] as const;

const getAttributes = [...listAttributes] as const;

const updateAttributes = [
  'creationDatetime',
  'mark',
  'maxMark',
  'outcome',
  'examLabel',
  'markerId',
  'markerDetails',
  'type',
  'exam',
  'question',
  'student',
  'studentDetails',
  'status',
  'markerComment',
] as const;

// Each selected student costs two index queries on the exam analytics endpoint,
// so the picker is bounded rather than letting a whole cohort be requested at once
export const MAX_ANALYTICS_STUDENTS = 20;

export const LegacyExamAttemptAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};
